module.exports = __webpack_public_path__ + "static/media/1007313.a3711936.jpg";